import { AgGridReact } from 'ag-grid-react'
import ModalBasic from '../../component/ModalBasic'

function QtyModel(props) {
    return (
        <ModalBasic
            id="voucher-receipt-details"
            classParams="!w-[80%] p-5"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <span className="text-blue text-[16px] font-semibold">Table details</span>
            <div className="input-fields bg-white shadow-normalShadow rounded-[10px] mt-2.5">
                <div className="table w-full rounded-[10px] pb-[30px]">
                    <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                        <div className="table-inner">
                            <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">{props.modalName ? props.modalName : ""}</h1>
                        </div>
                        <AgGridReact
                            rowData={props.requiredQtyList}
                            rowHeight={40}
                            columnDefs={props.colDefs}
                            onCellClicked={props.handleSelectChange}
                        />
                    </div>
                </div>
            </div>
        </ModalBasic>
    )
}

export default QtyModel
